import React from "react";

const Dashboard = () => {
  return (
    <div className="max-w-7xl mx-auto">
      <h2 className="text-3xl font-bold">Vista General</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
        <div className="bg-gray-800 rounded-lg p-6">
          <h3 className="text-gray-400 text-sm font-medium">Ventas Totales</h3>
          <p className="text-3xl font-bold mt-2">$120,000</p>
        </div>
        <div className="bg-gray-800 rounded-lg p-6">
          <h3 className="text-gray-400 text-sm font-medium">Ingresos</h3>
          <p className="text-3xl font-bold mt-2">$90,000</p>
        </div>
        <div className="bg-gray-800 rounded-lg p-6">
          <h3 className="text-gray-400 text-sm font-medium">Pedidos Completados</h3>
          <p className="text-3xl font-bold mt-2">500</p>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6">
        <div className="lg:col-span-2 bg-gray-800 rounded-lg p-6">
          <h3 className="text-lg font-semibold mb-4">Ventas Mensuales</h3>
          <div className="h-80 grid grid-cols-6 h-full items-end gap-4">
            {["Ene","Feb","Mar","Abr","May","Jun"].map((mes, i) => (
              <div key={i} className="flex flex-col items-center gap-2">
                <div className="w-full bg-primary-500 rounded-t-md" style={{ height: `${[60,40,70,60,80,50][i]}%` }}></div>
                <span className="text-xs text-gray-400">{mes}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-gray-800 rounded-lg p-6">
          <h3 className="text-lg font-semibold mb-4">Estado de los Pedidos</h3>
          <div className="flex justify-center items-center h-80">
            <div className="relative w-56 h-56">
              <svg className="w-full h-full" viewBox="0 0 36 36">
                <circle cx="18" cy="18" r="15.9155" fill="transparent" stroke="#2563eb" strokeWidth="3.5" strokeDasharray="75 25" strokeDashoffset="25"/>
                <circle cx="18" cy="18" r="15.9155" fill="transparent" stroke="#1d4ed8" strokeWidth="3.5" strokeDasharray="15 85" strokeDashoffset="0"/>
                <circle cx="18" cy="18" r="15.9155" fill="transparent" stroke="#1e3a8a" strokeWidth="3.5" strokeDasharray="10 90" strokeDashoffset="-15"/>
              </svg>
              <div className="absolute inset-0 flex flex-col items-center justify-center">
                <span className="text-3xl font-bold">1250</span>
                <span className="text-gray-400">Total Pedidos</span>
              </div>
            </div>
          </div>
          <div className="mt-6 space-y-3">
            {[
              { color: "bg-primary-500", label: "Completados", value: 937 },
              { color: "bg-primary-700", label: "En Proceso", value: 187 },
              { color: "bg-primary-900", label: "Pendientes", value: 125 },
            ].map((item, i) => (
              <div key={i} className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <span className={`w-3 h-3 rounded-full ${item.color}`}></span>
                  <span className="text-sm">{item.label}</span>
                </div>
                <span className="font-semibold">{item.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
